import { faTrashCan } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import useApi from "../hooks/use-api";

const DeleteButton = ({ deleteObject, endpoint, successCallback, errorCallback,confirmText = 'Click to confirm deletion', ...props }) => {
    const [deleteConfirm, setDeleteConfirm] = useState('init');
    const containerRef = useRef();

    const { processing, error, deleteRequest } = useApi();

    const _handleInitialClick = () => {
        setDeleteConfirm('confirm');
    }

    const _handleConfirmClick = () => {
        const deleteItem = async () => {
            const [data, status] = await deleteRequest(endpoint, deleteObject);

            if (status === 200) {
                successCallback();
                setDeleteConfirm('init');
            }
            else {
                errorCallback();
                setDeleteConfirm('init');
            }
        }

        deleteItem();
    }

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setDeleteConfirm('init');
            }
        }

        document.addEventListener('mousedown', handleOutsideClick);

        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [containerRef]);
    return (
        <>
            {
                processing
                    ?
                    <Button type="button" variant="danger" size="sm" disabled aria-label="Deleting" title="Deleting">
                        <Spinner animation="border" size="sm" />
                    </Button>
                    :
                    deleteConfirm === 'init'
                        ?
                        <Button type="button" variant="danger" size="sm" onClick={_handleInitialClick} aria-label="Delete" title="Delete" {...props}>
                            <FontAwesomeIcon icon={faTrashCan} />
                        </Button>
                        :
                        <Button type="button" variant="danger" size="sm" onClick={_handleConfirmClick} ref={containerRef} aria-label="Click to confirm deletion" title="Click to confirm deletion">
                            <>{confirmText}</>
                        </Button>
            }
        </>
    )
}

export default DeleteButton;